
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class LookupAvPromoCouponTypesGrid extends Serenity.EntityGrid<LookupAvPromoCouponTypesRow, any> {
        protected getColumnsKey() { return LookupAvPromoCouponTypesColumns.columnsKey; }
        protected getDialogType() { return LookupAvPromoCouponTypesDialog; }
        protected getIdProperty() { return LookupAvPromoCouponTypesRow.idProperty; }
        protected getInsertPermission() { return LookupAvPromoCouponTypesRow.insertPermission; }
        protected getLocalTextPrefix() { return LookupAvPromoCouponTypesRow.localTextPrefix; }
        protected getService() { return LookupAvPromoCouponTypesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}